import { render } from "./Fancybox.vue?vue&type=template&id=2e5957bc"
import script from "./Fancybox.vue?vue&type=script&lang=js"
export * from "./Fancybox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__